export default "__VITE_ASSET__O5I8WnWZ__"